module.exports = __webpack_public_path__ + "img/acdc.cc4dc5f5.jpg";